window.onload = function() {

    $('#country').change(function(){
        var lang = $(location).attr('pathname');
        lang.indexOf(1);
        lang = lang.split("/")[1];
        $.get("/"+lang+"/locale_selector/languages", { country: $(this).val() },
        function(data) {
            var language = $('#language');
            language.empty();
            $.each(data, function(key, value) {
                language.append($("<option></option>").attr("value",key).text(value));
            });
        });
    });

    $("#ppcontainer").show( "fast", function() {

        if ( (typeof popular_product_slider !== 'undefined') && (popular_product_slider) ) {

            jQuery(function ($) {
                'use strict';
                var canvas = $('#popular-products'),
                    frame = $('#popular-products .frame'),
                    slidee = $('#popular-products .slidee'),
                    scrollbar = $('#popular-products .scrollbar');

                var sly = window.sly = new Sly(frame, {
                    horizontal: 1,
                    itemNav: 'basic',
                    itemSelector: null,
                    smart: 1,
                    activateOn: 'click',
                    activateMiddle: 0,
                    scrollSource: null,
                    scrollBy: 1,
                    dragSource: null,
                    mouseDragging: 1,
                    touchDragging: 1,
                    releaseSwing: 1,
                    swingSpeed: 0.2,
                    elasticBounds: 0,
                    scrollBar: scrollbar,
                    dragHandle: 1,
                    dynamicHandle: 0,
                    minHandleSize: 50,
                    clickBar: 1,
                    syncSpeed: 0.5,
                    pagesBar: null,
                    activatePageOn: 'click',
                    pageBuilder: function (index) {
                        return '<li>' + (index + 1) + '</li>';
                    },
                    cycleBy: null,
                    cycleInterval: 5000,
                    pauseOnHover: 0,
                    startPaused: 0,
                    moveBy: 600,
                    speed: 300,
                    easing: 'swing',
                    startAt: 0,
                    keyboardNavBy: null,
                    draggedClass: 'sly_dragged',
                    activeClass: 'sly_active',
                    disabledClass: 'sly_disabled'
                });

                sly.init();

                $(window).resize(function (e) {
                    var resizeTimer;
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        sly.reload();
                    }, 100);
                });
            });

        }

    });

    $('.selectpicker').selectpicker({
        mobile: true
    });

    $('#backToTop').css('display','none');
    $(window).scroll(function(){
        if ($(this).scrollTop() > 50) {
            $('#backToTop').fadeIn('slow');
        } else {
            $('#backToTop').fadeOut('slow');
        }
    });
    $('#backToTop').click(function(){
        $("html, body").animate({ scrollTop: 0 }, 500);
        return false;
    });

    var dropdownMenu = "";
    var newHeight = 0;

    $('.header .dropdown-toggle').on('click', function (e) {
        dropdownParent = $(this).parent();
        if (dropdownParent.hasClass('open')) {
            newHeight = 0;
        } else {
            dropdownMenu = dropdownParent.find('.dropdown-menu');
            dropdownMenu.show();
            newHeight = dropdownMenu.innerHeight();
            dropdownMenu.hide();
        }
        $('#pushdown').animate({
            height: newHeight
        }, 200);
    });

    $('.header .dropdown').on('show.bs.dropdown', function(e){
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown(200);
    });

    $('.header .dropdown').on('hide.bs.dropdown', function(e){
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
        /*$('.dropdown').each(function() {
            if ($(this).hasClass('open')) {
                // do something
            } else {
                $('#pushdown').animate({
                    height: 0
                }, 200);
            }
        });*/
    });

    $(document).click(function() {
        $('#pushdown').animate({
            height: 0
        }, 200);
    });

    $('#productCarousel').carousel({
        interval: false
    });

    $('.carousel-selector').click( function(){
        var numberofthumbs = $('.carousel-selector').length;
        if (numberofthumbs > 3) {
            var slickid = $(this).parent().attr("data-slick-index");
            slickid = parseInt(slickid);
            $('.productThumbs').slick('slickGoTo', slickid);
        } else {
            $('#productCarousel').carousel($(this).data('id'));
        }
    });


    $('.productThumbs').show().slick({
        infinite: true,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '20px'
    });


    $('.productThumbs').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('#productCarousel').carousel(nextSlide);
    });

    $(document).ready(function() {
        $('.wiperinfo').hide();
        $('.wiperbtn').on( "click", function() {
            var id = $(this).attr('data-id');
            $('.wiperinfo').hide();
            $('.' + id).show();
            $('.wiperbtn').removeClass('active');
            $(this).addClass('active');
        });
    });

};
